import { Component, OnInit } from '@angular/core';
import { Base64UrlService } from '../../../services/base64url.service';
import { ModalService } from '../../../core/services/modal.service';
import { GraphAuthService } from '../../../modules/microsoft-graph/auth/services/graph-auth.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { BusinesscoItem, LogisticService } from '../../../services/logistic.service';
import { GridOptions } from '../../../core/components/grid/grid.types';
import { Grid } from '../../../core/components/grid/grid.model';

@Component({
  selector: 'tt-ac-reminder-proposal',
  templateUrl: './ac-reminder-proposal.component.html',
  styleUrls: ['./ac-reminder-proposal.component.css']
})
export class AcReminderProposalComponent implements OnInit {
    public setting?: Setting;

    public selectListCompanies: BusinesscoItem[] = [];

    public gridPosts?: GridOptions;

    public gridReceivers?: GridOptions;

    constructor(private base64: Base64UrlService, private modal: ModalService, private graphAuth: GraphAuthService, private datatask: DataTaskService, private logistic: LogisticService) {
        
    }

    private async loadSetting() {
        this.setting = (await this.datatask.Post(3088))[0];
    }

    private async loadCompanies() {
        this.selectListCompanies = await this.logistic.getCompanies();
    }

    private loadGridPosts() {
        if (!this.setting) return;

        if (!this.gridPosts) {
            this.gridPosts = new Grid()
                .setRememberId('w_acreminderproposal_grid')
                .setLoadDataFunction({
                    method: 3089,
                    parameters: { businessco_no: this.setting.businessco_no }
                })
                .setKendoConfig({ height: '100%' })
                .setToolbar({ wrapping: true });
        } else {
            this.gridPosts?.gridfunc?.read();
        }
    }

    private loadGridReceivers() {
        if (!this.setting) return;

        if (!this.gridReceivers) {
            this.gridReceivers = new Grid()
                .setRememberId('w_acreminderproposal_acreminder_grid')
                .setLoadDataFunction({
                    method: 3099,
                    parameters: { businessco_no: this.setting.businessco_no }
                })
                .setKendoConfig({ height: '100%' })
                .setToolbar({ wrapping: true });
        } else {
            this.gridReceivers?.gridfunc?.read();
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadCompanies();
        this.loadGridPosts();
        this.loadGridReceivers();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    businessco_no: string;
    gb_acreminderproposal_main: string;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('acReminderProposal', {
//        templateUrl: 'views/components/views/acReminderProposal/acReminderProposal.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: [
//            'base64',
//            'stateService',
//            'utilityService',
//            'modalService',
//            'translateService',
//            'acReminderProposalService',
//            'logisticService',
//            'rememberService',
//            'emailCreateService',
//            'graphAuthService',
//            'graphMailService',
//            'ttGridFactory',
//            function (base64, stateService, utilityService, modalService, translateService, acReminderProposalService, logisticService, rememberService, emailCreateService, graphAuthService, graphMailService, ttGridFactory) {

//                // #region VARIABLES & DEFINITIONS

//                const vm = this;

//                let variableNames = {
//                    gb_acreminderproposal_main: ''
//                };

//                let translations = {
//                    error: '',
//                    ok: ''
//                };

//                let progression = {
//                    label: '',
//                    plabel: '',
//                    field: '',
//                    remField: '',
//                    min: 0,
//                    max: 100,
//                    step: 0,
//                    finishclose: '',
//                    runProgress: ''
//                };

//                vm.model = {
//                    gridPostsReady: false,
//                    gridReceiversReady: false,
//                    bgAcReminderProposalMain: {
//                        selected: 'ACCUSTTRANS',
//                        buttons: [
//                            { id: 'ACCUSTTRANS', label: 'gb_acreminderproposal_main_accusttrans', color: 'primary', onClick: () => setAcReminderProposalMainView('ACCUSTTRANS') },
//                            { id: 'ACREMINDER', label: 'gb_acreminderproposal_main_acreminder', color: 'primary', onClick: () => setAcReminderProposalMainView('ACREMINDER') }
//                        ]
//                    },
//                    setting: {},
//                    selectListCompanies: [],
//                    updating: false
//                };

//                vm.gridPosts = new ttGridFactory({
//                    rememberId: 'w_acreminderproposal_grid',
//                    kendo: {
//                        height: '100%',
//                        sortable: true,
//                        aggregate: true,
//                        pager: false,
//                        selectable: false,
//                        filterable: false
//                    }
//                });

//                vm.gridReceivers = new ttGridFactory({
//                    rememberId: 'w_acreminderproposal_acreminder_grid',
//                    kendo: {
//                        height: '100%',
//                        sortable: true,
//                        aggregate: true,
//                        pager: false,
//                        selectable: false,
//                        filterable: false
//                    }
//                }).setCustomToolbarButtons([
//                    {
//                        name: 'acreminderproposal_approve_selected',
//                        text: 'acreminderproposal_approve_selected',
//                        func: () => progressFunc(),
//                        icon: 'fa-sync-alt',
//                        cssClass: 'btn btn-primary im-grid-btn-xs-r',
//                        translate: true
//                    }, {
//                        name: 'acreminderproposal_send_to_selected',
//                        text: 'acreminderproposal_send_to_selected',
//                        func: sendReminderToSelectedRows,
//                        disabled: sendReminderToSelectedDisabled,
//                        icon: 'fa-reply-all',
//                        cssClass: 'btn btn-primary im-grid-btn-xs-r',
//                        translate: true
//                    }
//                ]);

//                function checkToolbarButtonsVisibility() {
//                    vm.gridReceivers?.gridfunc?.refreshToolbarBtnDisability();
//                    vm.gridPosts?.gridfunc?.refreshToolbarBtnDisability();
//                }

//                // #endregion VARIABLES & DEFINITIONS

//                // #region EMAIL FUNCTIONS

//                async function sendReminderToSelectedDisabled() {
//                    try {
//                        await graphAuthService.getAccount();
//                    } catch (error) {
//                        console.dir(error);
//                        return 'hidden';
//                    }

//                    if (getSelectedRows()?.length > 0) {
//                        return false;
//                    }

//                    return true;
//                }

//                function sendReminderToSelectedRows() {
//                    let progress = {
//                        runProgress: 'START',
//                        label: 'progressbar',
//                        field: '',
//                        max: getSelectedRows()?.length ?? 0,
//                        min: 0,
//                        step: 0,
//                        finishclose: '1',
//                        abortclose: false,
//                    };

//                    modalService.progressInfo.max = getSelectedRows()?.length;

//                    modalService.showProgress(progress).then(function (value) {
//                        progress.runProgress = value;

//                        if (progress.runProgress === 'ABORT') {
//                            console.log('ABORT');
//                        } else if (progress.runProgress === 'FINISH') {
//                            loadGridReceivers();
//                        }
//                    });

//                    getSelectedRows()?.forEach(async (row) => {
//                        let email = await getEmailContent(row.acreminder_keyno);

//                        email.reports = [];
//                        email.documents = [];
//                        email.send_by_client = '1';

//                        await sendEmail(email);
//                        modalService.progressInfo.step++;
//                        progress.step++;
//                    });
//                }

//                function getSelectedRows() {
//                    return vm.gridReceivers?.gridfunc?.getDirtyRows().filter((dirtyRow) => dirtyRow.is_selected === true) ?? [];
//                }

//                async function getEmailContent(acReminderKeyno) {
//                    return (await emailCreateService.getEmailCreate({ webpage: 'acreminderproposal', argtype: 'acreminder_keyno', argvalue: acReminderKeyno }))[0];
//                }

//                async function sendEmail(ttEmail) {
//                    try {
//                        // TODO: look at this.
//                        ttEmail.send_by_client = '1';
//                        ttEmail.email_heading = base64.urlencode(ttEmail.email_heading);
//                        ttEmail.email_signature = base64.urlencode(ttEmail.email_signature);
//                        const data = await emailCreateService.sendEmail(ttEmail);

//                        if (data?.mailinfo && data.mailinfo.length > 0) {
//                            data.mailinfo.forEach((mailinfo) => {
//                                graphMailService.sendMessage({
//                                    subject: base64.urldecode(mailinfo.subject),
//                                    content: base64.urldecode(mailinfo.bodyHtml),
//                                    recipients: mailinfo.to,
//                                    ccRecipients: mailinfo.cc,
//                                    bccRecipients: mailinfo.bcc,
//                                    attachments: mailinfo.attachments,
//                                    userId: mailinfo.from,
//                                });
//                            });
//                        }
//                    } catch (error) {
//                        console.error(error);
//                    }
//                }

//                // #endregion EMAIL FUNCTIONS

//                // #region BUTTON GROUP SINGLE FUNCTION

//                function setAcReminderProposalMainView(id) {
//                    vm.model.bgAcReminderProposalMain.selected = vm.model.setting.gb_acreminderproposal_main = id;
//                }

//                // #endregion BUTTON GROUP SINGLE FUNCTION

//                // #region TRANSLATION FUNCTION

//                async function translate() {
//                    let data = await translateService.translateBatch(translations);

//                    Object.keys(translations).forEach((key) => {
//                        if (data?.[key]) translations[key] = data[key];
//                    });
//                }

//                // #endregion TRANSLATION FUNCTION

//                // #region LOAD PROCEDURE FUNCTION CALLS

//                async function loadSetting() {
//                    vm.model.setting = (await acReminderProposalService.getSetting())[0];
//                }

//                async function loadCompanies() {
//                    vm.model.selectListCompanies = await logisticService.listCompanies();
//                }

//                // #endregion LOAD PROCEDURE FUNCTION CALLS

//                // #region GRID PROCEDURE FUNCTION CALLS

//                async function loadGridPosts() {
//                    if (utilityService.validateParmsValue(vm.model.setting.businessco_no) !== true) return;

//                    vm.gridPosts.dataTask.loadData = {
//                        method: 3089,
//                        parameters: { businessco_no: vm.model.setting.businessco_no }
//                    };

//                    vm.model.gridPostsReady = true;

//                    if (vm.gridPosts.gridfunc !== null) vm.gridPosts.gridfunc.read();
//                }

//                async function loadGridReceivers() {
//                    vm.gridReceivers.dataTask.loadData = {
//                        method: 3099,
//                        parameters: { businessco_no: vm.model.setting.businessco_no }
//                    };

//                    vm.model.gridReceiversReady = true;

//                    if (vm.gridReceivers.gridfunc !== null) vm.gridReceivers.gridfunc.read();
//                }

//                // #endregion GRID PROCEDURE FUNCTION CALLS

//                // #region REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//                function rememberFunc(id) {
//                    Object.keys(variableNames).forEach((key) => {
//                        switch (key) {
//                            case 'gb_acreminderproposal_main':
//                                variableNames[key] = key;
//                                break;
//                            default:
//                                variableNames[key] = 'w_' + stateService.getCurrentName() + '.' + key;
//                                break;
//                        }
//                    });

//                    if (utilityService.validateParmsValue(variableNames[id]) !== true) return;

//                    let variableValue = null;

//                    switch (id) {
//                        case 'gb_acreminderproposal_main':
//                            if (utilityService.validateParmsValue(vm.model.setting.gb_acreminderproposal_main) !== true) return;

//                            variableValue = vm.model.setting.gb_acreminderproposal_main;
//                            break;
//                        default:
//                            break;
//                    }

//                    return rememberService.remember(variableNames[id], variableValue);
//                }

//                // #endregion REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//                // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//                vm.updateChanges = function () {
//                    vm.model.updating = true;

//                    acReminderProposalService.updateGrid({ businessco_no: vm.model.setting.businessco_no }).then(function (response) {
//                        if (response[0].errorcode !== '0') {
//                            modalService.show({
//                                type: 'warning',
//                                title: translations.error,
//                                message: response[0].errormessage,
//                                buttons: [{
//                                    label: translations.ok,
//                                    cssClass: 'btn-warning',
//                                    action: function (dialogItself) {
//                                        dialogItself.close();
//                                        vm.model.updating = false;
//                                    }
//                                }]
//                            });
//                        } else {
//                            vm.model.updating = false;
//                            loadGridPosts();
//                            loadGridReceivers();
//                        }
//                    });
//                }

//                // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//                // #region SHOW PROGRESSBAR DIALOGUE BOX FUNCTION

//                function activateProgress(items) {
//                    let increment = 1,
//                        skip = 0,
//                        failed = 0,
//                        step = 0;
//                    progression.step = 0;

//                    function doStep() {
//                        setTimeout(() => {
//                            modalService.progressInfo.finishclose = '0';

//                            if (progression.runProgress === 'ABORT') return;

//                            if (progression.step >= progression.max) {
//                                return;
//                            }

//                            step = progression.step + skip + failed;
//                            progression.field = 'ID: ' + items[step].acreminder_keyno;
//                            modalService.progressInfo.field = progression.field;

//                            acReminderProposalService.approveGridSelected({ acreminder_keyno: items[step].acreminder_keyno }).then(function (response) {
//                                if (response[0].errorcode !== '0') {
//                                    modalService.show({
//                                        type: 'warning',
//                                        title: translations.error,
//                                        message: response[0].errormessage,
//                                        buttons: [{
//                                            label: translations.ok,
//                                            cssClass: 'btn-warning',
//                                            action: function (dialogItself) {
//                                                dialogItself.close();

//                                                modalService.progressInfo.finishclose = '1';
//                                                progression.runProgress = 'ABORT';
//                                                modalService.progressInfo.abortclose = true;

//                                                doStep();
//                                            }
//                                        }]
//                                    });
//                                } else {
//                                    progression.step += increment;
//                                    modalService.progressInfo.step = progression.step;
//                                    modalService.progressInfo.finishclose = progression.finishclose;

//                                    doStep();
//                                }
//                            });
//                        });
//                    }

//                    doStep();
//                }

//                function progressFunc() {
//                    progression.runProgress = 'START';
//                    progression.label = 'progressbar';
//                    //progression.plabel = 'progressbar';
//                    progression.field = '';
//                    //progression.remField = '';
//                    //progression.min = 0;
//                    progression.max = 0;
//                    progression.step = 0;
//                    progression.finishclose = '1';
//                    progression.abortclose = false;

//                    let selectedRows = [];
//                    let allRows = vm.gridReceivers.gridfunc.getAllRows();

//                    allRows.forEach((item) => {
//                        if (item.is_selected === '1' || item.is_selected === true) {
//                            selectedRows.push(item);
//                        }
//                    });

//                    if (selectedRows.length === 0) return;

//                    progression.max = selectedRows.length;
//                    activateProgress(selectedRows);

//                    modalService.showProgress(progression).then(function (value) {
//                        progression.runProgress = value;

//                        if (progression.runProgress === 'ABORT') {
//                            console.log('ABORT');
//                        } else if (progression.runProgress === 'FINISH') {
//                            loadGridReceivers();
//                        }
//                    });
//                }

//                // #endregion SHOW PROGRESSBAR DIALOGUE BOX FUNCTION

//                // #region BUTTON GROUP SINGLE FUNCTION

//                vm.selectBgAcReminderProposalMain = function (value) {
//                    vm.model.bgAcReminderProposalMain.selected = value;
//                    vm.model.setting.gb_acreminderproposal_main = vm.model.bgAcReminderProposalMain.selected;

//                    rememberFunc('gb_acreminderproposal_main');
//                }

//                // #endregion BUTTON GROUP SINGLE FUNCTION

//                // #region FIELD CHANGE MULTI FUNCTIONS

//                vm.onChanged = function (value, id) {
//                    switch (id) {
//                        case 'businessco_no':
//                            if (utilityService.validateWatchValue(value, vm.model.setting.businessco_no) !== true) return;

//                            vm.model.setting.businessco_no = value;

//                            if (utilityService.validateParmsValue(vm.model.setting.businessco_no) !== true) return;

//                            loadGridPosts();
//                            loadGridReceivers();
//                            break;
//                        default:
//                            utilityService.setValueToVariable(value);
//                            break;
//                    }
//                };

//                // #endregion FIELD CHANGE MULTI FUNCTIONS

//                // #region ON INIT FUNCTION

//                vm.$onInit = async function () {
//                    translate();
//                    await loadSetting();
//                    loadCompanies();
//                    setAcReminderProposalMainView(vm.model.setting.gb_acreminderproposal_main);

//                    Promise.all([
//                        loadGridPosts(),
//                        loadGridReceivers()
//                    ]).then(() => Promise.resolve());

//                    document.querySelector('mgt-login').addEventListener('loginCompleted', checkToolbarButtonsVisibility);
//                }

//                vm.$onDestroy = function () {
//                    document.querySelector('mgt-login').removeEventListener('loginCompleted', checkToolbarButtonsVisibility);
//                }

//                // #endregion ON INIT FUNCTION

//            },
//        ],
//    });
//})();
